import { Button } from "@mui/material"
import { ReactElement } from "react"

interface IPreviousProps {
  onClick: () => void
  text?: string
}

export function PreviousButton(props: IPreviousProps): ReactElement {
  return (
    <Button
      onClick={props.onClick}
      sx={{
        padding: "0 20px 0 20px",
        height: "45px",
        justifySelf: "left",
        textTransform: "none",
        borderRadius: "999px",
        color: "#250048",
        backgroundColor: "#edf2f6",

        "&:hover": {
          color: "#edf2f6",
          backgroundColor: "#250048",
        },
      }}
    >
      {props.text || "previous"}
    </Button>
  )
}
